import React, { useState, useRef, useEffect } from "react";
import { themeColors } from "./themeUtils";

export default function PlatformSearchSelect({value,onChange,options,placeholder,theme,accent}){
  const C=themeColors(theme);
  const [open,setOpen]=useState(false);
  const [search,setSearch]=useState("");
  const ref=useRef(null);
  const sel=options.find(o=>o.value===value);
  const q=search.toLowerCase();
  const filtered=q?options.filter(o=>o.label.toLowerCase().includes(q)||o.value.toLowerCase().includes(q)):options;
  useEffect(()=>{if(!open)return;const h=e=>{if(ref.current&&!ref.current.contains(e.target)){setOpen(false);setSearch("");}};document.addEventListener("mousedown",h);return()=>document.removeEventListener("mousedown",h);},[open]);
  const bg=theme==="dark"?"rgba(255,255,255,.06)":"white";
  const bd=theme==="dark"?"rgba(255,255,255,.11)":"#E8E5E0";
  const dropBg=theme==="dark"?"#1C1C1F":"white";
  return(
    <div ref={ref} style={{position:"relative",width:"100%"}}>
      <button type="button" onClick={()=>setOpen(o=>!o)} style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"space-between",background:bg,border:`1.5px solid ${bd}`,borderRadius:10,color:sel?C.text:C.muted,fontSize:14,padding:"11px 14px",cursor:"pointer",fontFamily:"inherit",outline:"none",textAlign:"left",gap:8}}>
        <span style={{flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{sel?sel.label:(placeholder||"Select...")}</span>
        <svg width="10" height="6" viewBox="0 0 10 6" style={{flexShrink:0,opacity:.4,transform:open?"rotate(180deg)":"none",transition:"transform .15s"}}><path d="M0 0l5 6 5-6z" fill="currentColor"/></svg>
      </button>
      {open&&(
        <div style={{position:"absolute",top:"calc(100% + 4px)",left:0,right:0,zIndex:300,background:dropBg,border:`1px solid ${bd}`,borderRadius:10,boxShadow:"0 8px 24px rgba(0,0,0,.2)",maxHeight:220,display:"flex",flexDirection:"column"}}>
          {options.length>5&&(
            <div style={{padding:"8px 10px",borderBottom:`1px solid ${bd}`}}>
              <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search..." autoFocus
                style={{width:"100%",background:"transparent",border:"none",outline:"none",color:C.text,fontSize:13,fontFamily:"inherit"}}/>
            </div>
          )}
          <div style={{overflowY:"auto",flex:1}}>
            {filtered.map(o=>(
              <div key={o.value} onClick={()=>{onChange(o.value);setOpen(false);setSearch("");}}
                style={{padding:"9px 14px",fontSize:13,color:o.value===value?accent:C.text,cursor:"pointer",background:o.value===value?(accent+"12"):"transparent"}}
                onMouseOver={e=>e.currentTarget.style.background=accent+"08"} onMouseOut={e=>e.currentTarget.style.background=o.value===value?(accent+"12"):"transparent"}>
                {o.label}
              </div>
            ))}
            {filtered.length===0&&<div style={{padding:"12px 14px",fontSize:12,color:C.muted}}>No results</div>}
          </div>
        </div>
      )}
    </div>
  );
}
